import React, {useEffect, useState} from "react";
import {Modal, Button} from "react-bootstrap";
import {makeStyles} from "@material-ui/core/styles";
import {CircularProgress} from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import {connect} from "react-redux";
import * as play from "../../Play/_redux/PlayRedux";
import axios from "axios"

const useStyles = makeStyles({
    col: {
        "&:nth-child(2n+1)": {
            backgroundColor: "#EFF8FF"
        }
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
})

const EditVoidTicket = ({show, onHide, id, ticket, isLoading, setIsLoading, createTicket}) => {
    const classes = useStyles();

    const [error, setError] = useState("");
    const arr = ticket.ticketGames.map(game => ({
                gameId: game.gameId,
                option1: game.options.option1,
                optionX: game.options.optionX,
                option2: game.options.option2
    }));
    const [initialState, setInitialState] = useState(arr);
    console.log("state:", initialState)
    const handleChange = (e, index, option) => {
        let arr = [...initialState];
        arr[index][option] = Boolean(e.target.checked);
        setInitialState(arr)

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let allFalseArr = [];
        const group = {
            ticketGames : initialState,
            id: ticket.id
        }
        initialState.forEach((gameObj) => {
            let oneChecked = false;
            for (const option in gameObj) {
                if (option === "gameId") continue;
                if (gameObj[option] === true) {
                    oneChecked = true;
                }
            }
            allFalseArr.push(oneChecked)
        });
        if (allFalseArr.filter(item => item === false).length > 0) {
            setError("Bütün oyunlar üzrə proqnoz verilməlidir")
        } else {
            setIsLoading(true)
            axios.put(`${process.env.REACT_APP_API_URL}voidTickets/update`, group)
                .then((res) => {
                    console.log(res.data);
                    onHide(false)
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log(err)
                    setIsLoading(false)
                })
        }
    }



    return (
        <>
            <Modal
                size="md"
                show={show}
                onHide={onHide}
                aria-labelledby="create"
                centered
                className="modal pr-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="create">Proqnozları seçin.</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <div className="col-12 pl-4 pr-4">
                            {isLoading && (
                                <div className={classes.progresRoot}>
                                    <CircularProgress className={classes.progress}/>
                                </div>
                            )}

                            <div className="row">
                                {ticket.ticketGames.map((game, index) => (
                                    <div key={index} className={`col-12 col-md-12 col-lg-12 ${classes.col}`}>
                                        <div className="w-100 pt-2 pb-3 d-flex justify-content-between">
                                            <div
                                                className="d-flex align-items-center">{game.hostClub} - {game.guestClub}</div>
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <span>1</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "option1")}
                                                        value={initialState[index]?.option1}
                                                        checked={initialState[index]?.option1}
                                                    />
                                                </div>
                                                <div>
                                                    <span>x</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "optionX")}
                                                        value={initialState[index]?.optionX}
                                                        checked={initialState[index]?.optionX}
                                                    />
                                                </div>
                                                <div>
                                                    <span>2</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "option2")}
                                                        value={initialState[index]?.option2}
                                                        checked={initialState[index]?.option2}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                    <span className="text-danger">{error}</span>
                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit">Yenilə</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
};

export default connect(null, play.actions)(EditVoidTicket)